// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/EnderecosAdm_BuscaCepPorRuaELocationResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /relatorios/enderecos_adm/busca_cep_por_rua_e_location
 *
 * Resolves a CEP from a customer's street + location via reverse lookup,
 * persists it on the customer, and returns the customer id and resolved CEP.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface EnderecosAdm_BuscaCepPorRuaELocationResponseDados {
cliente_id?: string
cep?: string
}

export type EnderecosAdm_BuscaCepPorRuaELocationResponse = ApiResponse<EnderecosAdm_BuscaCepPorRuaELocationResponseDados>;

registerResponseContract('EnderecosAdm_BuscaCepPorRuaELocationResponse', {
  cliente_id: { type: 'string',  required: false },
  cep:        { type: 'string',  required: false },
})
